
import * as consts from '../constants';
import commonFunctions from '../commonFunctions';

class companyApi {
    static loadCompanies(token) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/configuration/companies';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static loadCompany(token, id) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/configuration/company/' + id, 'GET');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static saveCompany(token, company) {
        return new Promise((resolve, reject) => {
            let method = 'POST';
            if (company.id > -1)
                method = 'PUT';

            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/configuration/company', method);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(company));
        });
    }

    static deleteCompany(token, companyId) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/configuration/company/' + companyId, 'DELETE');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve();
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

}

export default companyApi;
